<template>
  <div
    id="reports"
    class="row"
  >
    <div class="col-12">
      <v-col
        v-if="downloading"
        class="subtitle-1 text-center"
        cols="12"
      > Cargando por favor espere...
      </v-col>
      <v-progress-linear
        indeterminate
        :background-color="backgroundLoadingColor"
        :color="loadingColor"
        height="10"
        v-if="downloading"
      ></v-progress-linear>
      <v-form
        ref="form"
        v-model="valid"
        lazy-validation
        @submit.prevent="reset"
        @keydown="form.onKeydown($event)"
      >
        <v-container grid-list-xl>
          <toolbar
            :title="title"
            :loading="form.busy"
            :buttons="buttons"
            @getPDF="getPDF"
          />
          <v-layout
            class="wrap justify-space-around form-body"
          >
            <v-col lg="4" md="6" sm="6" cols="12">
              <v-autocomplete
                v-model="form.year"
                :rules="[rules.required]"
                :items="yearsList"
                label="Año"
              >
              </v-autocomplete>
            </v-col>
          </v-layout>
        </v-container>
      </v-form>
    </div>
  </div>
</template>

<script>
import Form from 'vform';
import { format, parseISO } from 'date-fns';
import { mask } from 'vue-the-mask';
import { mapGetters } from 'vuex';
import Toolbar from '~/components/Toolbar';
import 'vuetify/src/styles/main.sass';

Form.axios = window.axios;
export default {
  middleware: 'auth',
  metaInfo() {
    return { title: 'Reporte Seniat Numeraciones' };
  },
  components: {
    Toolbar,
  },
  computed: {
    ...mapGetters({
      user: 'auth/user',
      loadingColor: 'theme/loadingColor',
      backgroundLoadingColor: 'theme/backgroundLoadingColor',
      themeColor: 'theme/themeColor',
      navbarColor: 'theme/navbarColor',
    }),
  },
  directives: {
      mask,
    },
  data: () => ({
    title: 'Reporte Seniat Numeraciones',
    form: new Form({
      year: format(parseISO(new Date().toISOString()), 'yyyy'),
      busy: false,
    }),
    valid: false,
    rules: {
      required: (v) => !!v || 'El campo es requerido.',
    },
    documents: 0,
    downloading: false,
    buttons: [
      {
        id: 'cancel',
        icon: 'mdi-download',
        name: 'Descargar PDF',
        event: 'getPDF',
        color: 'green',
      },
    ],
    showFilters: false,
    yearsList: [
      '2023', '2024', '2025', '2026', '2027', '2028', '2029', '2030',
    ],
  }),
  mounted() {
  },
  methods: {
    async download() {
      this.downloading = true;
      this.form.busy = true;

      // eslint-disable-next-line
      const { data } = await this.getReport();
      const title = `Reporte Seniat Numeraciones Fecha ${format(parseISO(new Date().toISOString()), 'dd-MM-yyyy')}`;
      this.downloadFile(data, title);
      setTimeout(() => {
        this.downloading = false;
        this.form.busy = false;
        this.progress = 0;
      }, 1000);
    },
    getReport() {
      const url = '/api/reportDocuments/totalsWeekly';
      return window.axios({
        method: 'post',
        url,
        responseType: 'arraybuffer',
        data: this.form,
      }).catch((e) => {
        // eslint-disable-next-line
        console.log(e);
      });
    },
    downloadFile(response, filename) {
      // Es necesario crear un nuevo objeto blob con mime-type establecido explícitamente
      // de lo contrario, solo Chrome funciona como debería  //application/vnd.ms-excel
      // application/application/vnd.openxmlformats-officedocument.spreadsheetml.sheet
      const newBlob = new Blob([response], { type: 'application/vnd.ms-excel' });
      // IE no permite usar un objeto blob directamente como enlace href, en su lugar, es necesario usar msSaveOrOpenBlob
      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(newBlob);
        return;
      }
      // Para otros navegadores: Cree un enlace que apunte al ObjectURL que contiene el blob..
      const data = window.URL.createObjectURL(newBlob);
      const link = document.createElement('a');
      link.href = data;
      link.download = `${filename }.xlsx`;
      link.click();
      setTimeout(() => {
        // Para Firefox es necesario retrasar la revocación de ObjectURL
        window.URL.revokeObjectURL(data);
      }, 100);
    },
    getColor(status) {
        if (status.indexOf('1') !== -1) return 'green';
        return 'red';
    },
    getPDF() {
      const name = `Reporte Seniat Numeraciones Fecha ${format(parseISO(new Date().toISOString()), 'dd-MM-yyyy')}`;
      const url = '/api/reportDocuments/totalsWeeklyPDF';
      this.downloading = true;
      this.form.busy = true;
      window.axios({ url, method: 'post', responseType: 'arraybuffer', data: this.form }).then((response) => {
        if (response.data) {
          this.downloadFilePDF(response, `${name}`, 'pdf');

          setTimeout(() => { this.dowloading = false; }, 1000);

          this.$store.dispatch('notifications/show', {
            message: 'Se ha descargado el PDF con éxito.',
            type: 'success',
          });
          this.downloading = false;
          this.form.busy = false;
        } else {
          this.$store.dispatch('notifications/show', {
            message: 'El documentos no contiene PDF.',
            type: 'error',
          });
          this.downloading = false;
          this.form.busy = false;
        }
      })
      .catch(() => {
      });
    },
    downloadFilePDF(response, filename) {
      // Es necesario crear un nuevo objeto blob con mime-type establecido explícitamente
      // de lo contrario, solo Chrome funciona como debería  //application/vnd.ms-excel
      // application/application/vnd.openxmlformats-officedocument.spreadsheetml.sheet
      const newBlob = new Blob([response.data], { type: 'application/pdf' });
      // IE no permite usar un objeto blob directamente como enlace href, en su lugar, es necesario usar msSaveOrOpenBlob
      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(newBlob);
        return;
      }
      // Para otros navegadores: Cree un enlace que apunte al ObjectURL que contiene el blob..
      const data = window.URL.createObjectURL(newBlob);
      const link = document.createElement('a');
      link.href = data;
      link.download = `${filename}.pdf`;
      link.click();
      setTimeout(() => {
        // Para Firefox es necesario retrasar la revocación de ObjectURL
        window.URL.revokeObjectURL(data);
      }, 100);
    },
  },
};
</script>
